import Vue from 'vue'
import App from './App.vue'

import EpidemService from '@/services/epidemiological.service'

Vue.config.productionTip = false

new Vue({
  provide: { $services: { epi: EpidemService } },
  render: h => h(App)
}).$mount('#app')
